export const DASHBOARDS_VES = 'dashboardsVES';

export const DASHBOARDS_VES_ACTIONS_NAME = {
  getRegionStatistic: `${DASHBOARDS_VES}/getRegionStatistic`,
  getTopCountryPartners: `${DASHBOARDS_VES}/getTopCountryPartners`,
  getTopEffectiveRegions: `${DASHBOARDS_VES}/getTopEffectiveRegions`,
  getTopEffectiveRegionsRating: `${DASHBOARDS_VES}/getTopEffectiveRegionsRating`,
  getEventsCountByTypes: `${DASHBOARDS_VES}/getEventsCountByTypes`,
  getAgreementsCountByTypes: `${DASHBOARDS_VES}/getAgreementsCountByTypes`,
  getEventTypes: `${DASHBOARDS_VES}/getEventTypes`,
  getEventVedTypes: `${DASHBOARDS_VES}/getEventVedTypes`,
  getEventStatuses: `${DASHBOARDS_VES}/getEventStatuses`,
  getPlannedEvents: `${DASHBOARDS_VES}/getPlannedEvents`,
  exportRegionEffectivnessRatingExcel: `${DASHBOARDS_VES}/exportRegionEffectivnessRatingExcel`,
};

export const DASHBOARDS_VES_MUTATIONS_NAME = {
  setRegionStatistic: `${DASHBOARDS_VES}/setRegionStatistic`,
  setTopCountryPartners: `${DASHBOARDS_VES}/setTopCountryPartners`,
  setTopEffectiveRegions: `${DASHBOARDS_VES}/setTopEffectiveRegions`,
  setTopEffectiveRegionsRating: `${DASHBOARDS_VES}/setTopEffectiveRegionsRating`,
  setEventsCountByTypes: `${DASHBOARDS_VES}/setEventsCountByTypes`,
  setAgreementsCountByTypes: `${DASHBOARDS_VES}/setAgreementsCountByTypes`,
  setEventTypes: `${DASHBOARDS_VES}/setEventTypes`,
  setEventVedTypes: `${DASHBOARDS_VES}/setEventVedTypes`,
  setEventStatuses: `${DASHBOARDS_VES}/setEventStatuses`,
  setPlannedEvents: `${DASHBOARDS_VES}/setPlannedEvents`,
};

export const DASHBOARDS_VES_GETTERS_NAME = {
  getRegionStatistic: `${DASHBOARDS_VES}/getRegionStatistic`,
  getTopCountryPartners: `${DASHBOARDS_VES}/getTopCountryPartners`,
  getTopEffectiveRegions: `${DASHBOARDS_VES}/getTopEffectiveRegions`,
  getTopEffectiveRegionsRating: `${DASHBOARDS_VES}/getTopEffectiveRegionsRating`,
  getEventsCountByTypes: `${DASHBOARDS_VES}/getEventsCountByTypes`,
  getAgreementsCountByTypes: `${DASHBOARDS_VES}/getAgreementsCountByTypes`,
  getEventTypes: `${DASHBOARDS_VES}/getEventTypes`,
  getEventVedTypes: `${DASHBOARDS_VES}/getEventVedTypes`,
  getEventStatuses: `${DASHBOARDS_VES}/getEventStatuses`,
  getPlannedEvents: `${DASHBOARDS_VES}/getPlannedEvents`,
};
